import { HomeBanner } from './components';

export const Home = {
  Banner: HomeBanner,
};
